<template>
	<div>
		<div class="pras_box">
			<aside class="pras_left">
				<div class="pras_title">产品分类</div>
				<div v-for="(itme,i) in classifyList" :key="i"><span @click="xin.goUrl('/oneDetails?cid='+itme.id)">{{itme.title}}</span></div>
			</aside>
			<main class="pras_right">
				<nav class="arrow_box clearfloat">
					<span class="arrow_ywz">您的位置：</span>
					<div class="arrow">
						<span class="to" @click="xin.goUrl('/index')">首页</span>
						<span class="el-icon-arrow-right"></span>
						<span class="topc">产品中心</span>
					</div>
				</nav>
				<section v-loading="loading3" class="pras_img">
					<el-carousel trigger="click" height="450px" class="banner-box"  ref="carousel" :interval="5000" arrow="always">
						<el-carousel-item  v-for="(item) in dataList" :key="item.id">
							<img @click="xin.goNew(item.url)" :src="item.images" :alt="item.title">
						</el-carousel-item>
					</el-carousel>
				</section>
				<section class="longa">
					<div class="kuang search_long">
						<span class="el-icon-search"></span>
						<div class="searchInp">
							<el-input class="nav_search" v-model="searchVal" @change="tosearch"
						select-when-unmatched placeholder="按货号/产品名/其他搜索"></el-input>
						</div>
					</div>
					<div class="kuang btn_long"  @click="xin.goUrl('/askData')">
						<span class="el-icon-message"></span>
						<span>操作说明集索取</span>
					</div>
				</section>
				<section>
					<div class="journalism_title">
						新闻动态 <span class="jour_new">NEWS</span>
					</div>
					<div class="jour_box">
						<article class="jour_zi" v-for="itme in newList" :key="itme.id">
							<div >
								<div class="jour_item">
									<div class="">{{itme.create_time}}</div>
									<div @click="xin.goUrl('/jourDetails?nid='+itme.id)" class="jour_btn laing_btn">{{itme.tab}}</div>
								</div>
								<div @click="xin.goUrl('/jourDetails?nid='+itme.id)" class="jour_title">
									{{itme.title}}
								</div>
								<div class="jour_ceuntn">
									{{itme.subtitle}}
								</div>
							</div>
							<div class="flo_ri iconfont icon-new"></div>
						</article>
					</div>
					<div class="chani">
						<span @click="xin.goUrl('/journalism/news')">查看更多</span>
					</div>
				</section>
				<section>
					<div class="product_title">
						热门产品分类
						<span class="pro_pose">Hot product classification</span>
					</div>
					<div v-loading="loading" class="product_list min_he200">
						<article class="pro_zi" v-for="itme in topCategory" :key="itme.id" @click="xin.goUrl('/oneDetails?cid='+itme.id)">
							<div class="pro_img">
								<img :src="itme.images" />
							</div>
							<div class="pro_title_zi">
								<div class="pro_title">{{itme.title}}</div>
								<div class="geng">{{itme.subtitle}}</div>
							</div>
						</article>
					</div>
				</section>
				<section>
					<div class="product_title">
						推荐产品
						<span class="pro_pose">RECOMMENDED PRODUCT </span>
					</div>
					<div v-loading="loading2" class="product_list min_he200">
						<article class="pro_zi" v-for="itme in topProduct" :key="itme.id" @click="xin.goUrl('/products/'+itme.id)">
							<div class="pro_img">
								<img :src="itme.cover_img" />
							</div>
							<div class="pro_title_zi">
								<div class="pro_title">{{itme.title}}</div>
								<div class="geng">{{itme.subtitle}}</div>
							</div>
						</article>
					</div>
				</section>
			</main>

		</div>

	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'
	export default {
		data() {
			return {
				loading:true,
				loading2:true,
				loading3:true,
				searchVal:"",//搜索
				newList:[],//新闻动态
				topProduct:[],//推荐产品
				topCategory:[],//推荐产品
				currentIndex: 0, //轮播图索引
				dataList: [], //轮播图
			}
		},
		created() {
			this.Postbanner();
			this.Postnews();
			this.PostTopProduct();
			this.PostTopCategory();
		},
		computed: {
			...mapState(['classifyList'])
		},
		methods: {
			tosearch(e){//搜索
				e = e.replace(/\s+/g,"")
				if(e)this.xin.goUrl('/search?val='+e);
			},
			async Postbanner(){//获取轮播图
				this.loading3 = true;
				let {data} = await this.api.Postbanner();
				this.dataList = data;
				this.loading3 = false;
			},
			async Postnews(){//获取新闻动态
				let {data} = await this.api.Postnews();
				this.newList = data;
			},
			async PostTopProduct(){//获取推荐产品
				this.loading = true;
				let {data} = await this.api.PostTopProduct();
				this.topProduct = data;
				this.loading = false;
			},
			async PostTopCategory(){//获取产品分类
				this.loading2 = true;
				let {data} = await this.api.PostTopCategory();
				this.topCategory = data;
				this.loading2 = false;
			},
		}
	}
</script>

<style lang="scss" scoped>
.el-icon-search{
		float: left;
		line-height: 50px;
		margin: 0 0px 0 10px;
	}
	.searchInp{
		float: left;
		width: 200px;
		line-height: 50px;
		/deep/ .el-input__inner{
			border: none;
		}
	}
.banner-box{
	img{
		height: 100%;
	}
}
	.pras_box {
		width: 1200px;
		margin: 50px auto 0;
		display: flex;
		justify-content: space-between;

		.pras_left {
			color: #666666;
			font-size: 18px;

			div {
				line-height: 36px;
			}

			span {
				cursor: pointer;
			}

			.pras_title {
				font-size: 26px;
				font-weight: 500;
				color: #333333;
			}
		}

		.pras_right {
			width: 900px;

			.product_title {
				margin-top: 40px;
				font-size: 30px;
				color: #333;

				.pro_pose {
					color: #8F8F8F;
					font-size: 14px;
					margin-left: 10px;
				}
			}

			.product_list {
				.pro_zi {
					width: 210px;
					.pro_img{
						height: 157px;
						img{
							height: 100%;
						}
					}
				}
			}

			/* 新闻动态 */
			.journalism_title {
				margin-top: 50px;
				color: #333;
				font-size: 24px;

				.jour_new {
					margin-left: 10px;
					font-size: 14px;
					color: #666666;
				}
			}

			.jour_box {
				margin-top: 24px;
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;

				.jour_zi {
					border-bottom: solid 1px #e6e6e6;
					padding: 30px 0;
					width: 400px;
					color: #8F8F8F;
					font-size: 15px;
					display: flex;

					div {
						line-height: 35px;
					}

					.jour_title {
						cursor: pointer;
						font-size: 19px;
						color: #333333;
					}
					.jour_item{
						display: flex;
					}
					.jour_btn {
						margin-left: 10px;
						display: inline-block;
						border-radius: 0px;
						line-height: 24px;
						width: auto;
						height: 24px;
						padding: 0 5px;
					}
				}
			}

			/* 远程搜索 */
			.longa {
				margin-top: 60px;
				display: flex;
				justify-content: space-around;

				.kuang {
					width: 280px;
					height: 50px;
					border: 1px solid #A0A0A0;
					border-radius: 25px;

					input {
						margin: 5px 5px 5px 15px;
						border: none;
						width: 250px;
						height: 40px;
						font-size: 18px;
					}
				}

				.search_long {}

				.btn_long {
					cursor: pointer;
					line-height: 50px;
					font-size: 18px;
					color: #333333;
					text-align: center;
				}
			}

			.pras_img {
				// width: 600px;
				margin: 0 auto;
				img {
					width: 100%
				}
			}
		}
	}
</style>
